// extracted by mini-css-extract-plugin
export default {"question":"styles_question__heXm6","title":"styles_title__egtjq","desktop":"styles_desktop__2U2iB","extra":"styles_extra__P3Dhl","answers":"styles_answers__h+Uyb"};